import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "send",
  "use": "send-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"send\"><path d=\"M64.5 672V448.5l480-64.5-480-64.5V96l672 288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/send.svg
// module id = AsDT
// module chunks = 1